import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { GetQuotesProps, GetQuotesResponse } from 'shared/services';

export function useQueryQuotes(props: GetQuotesProps) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, isFetching } = useQuery<GetQuotesResponse, Error>(
    ['quotes', props],
    () => quoteService.getQuotes(props),
    {
      onError: error => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
      keepPreviousData: true,
    }
  );
  return { quotes: data, isLoading, isFetching } as const;
}
